import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetElementsDataserie } from '../../../../../hooks/services/sKPI/useOfBoard';
import { OverflowSet } from '@fluentui/react';
import PropTypes from 'prop-types';
import { __onRenderOverflowItem, __onRenderOverflowButton } from '../../../../../common/CommonFuctions';
import MainAppContext from '../../../../../MainAppContext';
import { useContext } from 'react';
import { getGridLocalization, showMessage } from '../../../../../common/Helpers';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { deleteVariableDataserieFromElement } from '../../../../../services/sKPI/dataserie.service';
import { __MessageTypes } from '../../../../../common/Dictionaries';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import MessageBoxInfoComplex from '../../../../Common/Message/MessageBoxInfoComplex';

const SidePanelVariables = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);

    const {
        inputParam_IsPanelOpen = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_ElementId = null,
        inputParam_OnDeleteBoardElement,
    } = props;
    
    const [dataserieList, setDataSerieList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetElementsDataserie(inputParam_ElementId, dataserieList, setDataSerieList, inputParam_IsPanelOpen)

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setDataSerieList(prevState => ({
            ...prevState,
            fireUpdate: true, 
            data: null
        }))
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onDeleteBoardElement = (dataserieId) => {
        deleteVariableDataserieFromElement(dataserieId).then((response) => {
            if (response.data.succeeded) {
                if (response.data.data.result) {
                    setDataSerieList(prevState => ({
                        ...prevState,
                        fireUpdate: true, 
                        data: dataserieList.data.filter(dataserie =>
                            dataserie.id !== dataserieId
                        )
                    }));
            
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    inputParam_OnDeleteBoardElement && inputParam_OnDeleteBoardElement(true)
                }
                else {
                    if (response.data.data.l_validations.length > 0) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }
            }
            else {
                if (response.data.data.l_validations.length > 0) {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }

                inputParam_OnDeleteBoardElement && inputParam_OnDeleteBoardElement(false)
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            inputParam_OnDeleteBoardElement && inputParam_OnDeleteBoardElement(false)
        });
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <MessageBoxInfoComplex
                            inputParam_TranslateText={ true }
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return dataserieList.data[rowIndex.boundindex].id;
        }
        return dataserieList.data[rowIndex]?.id;
    };
    
    const nameCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const item = dataserieList.data.find(x => x.id === itemId);
        return  <div>
                    { `${item.contractual === true ? '(C) ' : ''}${item.variableName}` }
                </div>
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        return  <div>
                    <OverflowSet
                        className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                        role="menubar"
                        items={[
                            {
                                key: 'item1',
                                icon: 'Delete',
                                name: t('data-lang-btn-delete'),
                                title: t('data-lang-btn-delete'),
                                onClick: inputParam_OnDeleteBoardElement && (() => onDeleteBoardElement(itemId)),
                            }
                        ]}
                        onRenderOverflowButton={__onRenderOverflowButton}
                        onRenderItem={__onRenderOverflowItem}
                    />
                </div>
    };

    const getColumns = () => {
        return [
            
                { index: null, text: 'ID',                               dataField: 'id',           width: '0%',  columntype: 'textbox', editable: false, hidden: true },
                { index: null, text: t('data-lang-lbl-measurementunit'), dataField: 'variableUM',   width: '20%', columntype: 'textbox', editable: false },
                { index: null, text: t('data-lang-lbl-name'),            dataField: 'variableName', width: '70%',
                    createwidget: (row, column, value, htmlElement) => { ReactDOM.render(nameCellsRenderer(row), htmlElement); },
                    initwidget: (row, column, value, htmlElement) => { ReactDOM.render(nameCellsRenderer(row), htmlElement); },
                },
                { index: null, text: t('data-lang-lbl-actions'),         dataField: 'acciones',     width: '10%',
                    createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                    initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                },
        ].filter(x => (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) ? true : x.dataField !== "acciones" )
    }
    
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-variables') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.largeFixed }
            >
                <Row className="pt-3">
                    {
                        dataserieList.data &&
                        <JqxGrid
                            altrows={true}
                            enabletooltips={true}
                            width={'100%'}
                            theme={'light'} 
                            editable={false}
                            height={"550px"}
                            sortable={false}
                            filterable={false}
                            showfilterrow={false} 
                            localization={getGridLocalization(t)}
                            source={ new jqx.dataAdapter({
                                localData: dataserieList.data,
                                dataType: 'array',
                                dataFields: [            
                                    { name: 'id',           type: 'int' },
                                    { name: 'variableUM',   type: 'string' },
                                    { name: 'variableName', type: 'string' },
                                ],
                                id: 'id'
                            })}
                            columns={getColumns()}
                        />
                    }
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

///Proptypes
SidePanelVariables.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_ElementId: PropTypes.number.isRequired,
    inputParam_OnDeleteBoardElement: PropTypes.func.isRequired,
};

export default SidePanelVariables;